<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
			<div class="container">
				<div class="breadcrumb-content text-center">
					<h2>专栏</h2>
				</div>
			</div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
			<div class="container">
				<div class="row flex-row-reverse">
					<div class="col-lg-9">
						<div class="row row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1">
							<div class="col mb-6" v-for="(item,index) in merchantList" :key="item.id">
								<div class="blog-wrap">
									<div class="blog-img mb-2">
										<router-link :to="{path:'/merchantDetail/'+item.zk_id}"><img
												:src="item.image | imgfilter" alt=""></router-link>
									</div>
									<div class="blog-content">
										<router-link :to="{path:'/merchantDetail/'+item.zk_id}">
											<div>{{item.name}}</div>
										</router-link>
									</div>
								</div>
							</div>
						</div>
						<div class="pagination-style mt-3">
							<div class="block">
								<el-pagination @current-change="handleCurrentChange" :pager-count="5"
									:current-page="currentPage" layout="total, prev, pager, next" :total="total">
								</el-pagination>
							</div>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="sidebar-wrap sidebar-margin-right">
							<div class="sidebar-widget">
								<h3 class="sidebar-widget-title">全部企业厂商</h3>
								<div class="sidebar-categori">
									<el-menu default-active="2" unique-opened text-color="#666666"
										active-text-color='#009C44' class="el-menu-vertical-demo"
										@select="handleSelect">
										<el-submenu :index="menu.id.toString()" v-for="(menu,index) in cateCompanyList"
											:key="menu.id">
											<template slot="title"><span>{{menu.cate_name}}</span></template>
											<el-menu-item :index="child.id.toString()"
												v-for="(child,cindex) in menu.children" :key="child.id">
												{{child.cate_name}}</el-menu-item>
										</el-submenu>
									</el-menu>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getMerchantList,
	getCateCompanyList,
} from '@/api'
export default {
	data() {
		return {
			nameInfo: '',
			bgImg: require('../static/images/banner/banner-3.jpg'),
			cateCompanyList: [],
			merchantList: [],
			total: 0,
			currentPage: 1,
			pid: 0,
		}
	},
	created() {
		this.getCateCompanyList()
		this.getMerchantList()
	},
	computed: {
		isLogin() {
			return getCookies("webtoken");
		},
	},
	methods: {

		// 获取专栏列表
		async getCateCompanyList() {
			const res = await getCateCompanyList()
			this.cateCompanyList = res.data
		},
		// 获取分类商家列表
		async getMerchantList() {
			const res = await getMerchantList({
				pid: this.pid,
				page: this.currentPage,
				limit: 10
			})
			this.total = res.data.count
			this.merchantList = res.data.list
		},
		// 页数跳转
		handleCurrentChange(val) {
			this.currentPage = val
			this.getMerchantList()
			document.documentElement.scrollTop = 0
		},
		// 专栏分类选择
		handleSelect(key, keyPath) {
			this.pid = key || 0
			this.currentPage = 1
			this.getMerchantList()
			document.documentElement.scrollTop = 0
		},
	}
}
</script>

<style>

</style>
